import { THEME } from 'GlobalStyles';

export const styles = {
  emptyImage: {
    margin: THEME.spacing(3, 0, 5)
  }
};
